export default __webpack_public_path__ + "static/media/kitchen-pack-12.55428b19.png";